angular.module('cpm').constant('SERVICE_LOCATIONS', {
    REFLOW_API: '//api.reflow.tv/',
    CPM_API: '/api/',
    CDN_URL: 'https://cdn.ctnsnet.com/ase/fetch/uas/',
    INSIGHT_URL: 'https://insight.reflow.tv/'
});
